const frameBrowser = {
  frameBrowserHeader: 'Aquí puedes ver donde están',
  frameBrowserHeader2: 'los frames en la obra',
  yourFrames: 'Tus Frames',
  claimFrame: 'Pedir Frame'
 };
  
 module.exports = frameBrowser; 